export default "__VITE_ASSET__f7b23262__"